import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageShell from '../../components/PageShell';
import Tabs from '../../components/Tabs';
import { useHubExcelExport } from '../../components/ExcelExportButton';
import { useRegisterPageExports } from '../../exports/pageExports';
import { resolveTabs } from '../../i18n/resolveTabs';
import CapacityAuditTab from '../tdabc/CapacityAuditTab';

/* Pilotage temps — les deux LECTURES du temps, sorties du hub Temps le
   2026-08-26 (demande Olivier).

     • Audit = les contrôles du modèle (ce qui ne se réconcilie pas).

   « Vue d'ensemble » est passée en tête de « Saisie des temps » le 2026-08-30 :
   on lit la cascade là où l'on saisit les heures qui la nourrissent.

   Temps SAISIT (calendrier, temps standard), Pilotage temps LIT : c'est la même
   séparation par métier que dans Finance. Elles étaient les deux derniers
   onglets du hub Temps, derrière un séparateur qui disait déjà que la nature
   changeait ; une section les distingue mieux qu'un filet.

   La section vit pour l'instant dans le **Chantier**, la bande réservée à
   l'exploitant : elle n'est pas finie. Sa clé reste `hr-time-pilot` et son
   périmètre `people` — le jour où elle rejoint People, seul le menu bouge.

   Gabarit : <PageShell framed> + <Tabs> + sous-pages en embedded. */
const TAB_DEFS = [
  { id: 'audit', labelKey: 'rentabilite:capacity.tabs.audit' },
];

export default function TimePilotHub({ activeTenant, addToast, year }) {
  const { t } = useTranslation();
  const [tab, setTab] = useState('audit');
  const TABS = resolveTabs(TAB_DEFS, t);
  const tenantId = activeTenant?.id;

  const renderTab = (id) => {
    switch (id) {
      case 'audit':
        return <CapacityAuditTab tenantId={tenantId} year={year} addToast={addToast} />;
      default:
        return null;
    }
  };

  const excel = useHubExcelExport({
    tabs: TABS.map(tb => ({ label: tb.label, render: () => renderTab(tb.id) })),
    fileBase: t('people:timePilot.title'),
    tenantName: activeTenant?.name,
    year,
    addToast,
  });
  useRegisterPageExports(useMemo(() => ([
    { id: 'excel', label: 'Excel', run: excel.run },
  ]), [excel.run]));

  return (
    <PageShell framed title={t('people:timePilot.title')}>
      {TABS.length > 1 && <Tabs tabs={TABS} active={tab} onChange={setTab} />}
      <div className="page-shell__panel">{renderTab(tab)}</div>
      {excel.stage}
    </PageShell>
  );
}
